import { queryKeys } from '@/constants/queryKeyFactory'
import { useMutation, useQuery } from '@/hooks/api'
import { ApiResponse, PaginationParams, QueryOptions } from '@/interfaces/api.interface'
import { INotification } from '@/interfaces/notification.interface'
import { queryClient } from '@/lib/queryClient'
import { notificationSvc } from '@/services/notification.service'


export function useNotifications(params: PaginationParams = {}, options: QueryOptions = {}) {
  return useQuery<ApiResponse<INotification[]>>(
    queryKeys.notifications.list(params),
    () => notificationSvc.get<INotification>({
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      sort: params.sort,
      filter: params.filter,
      searchFilters: params.searchFilters
    }),
    { ...options, showLoader: false }
  )
}

export function useAllNotifications(params: PaginationParams = {}, options: QueryOptions = {}) {
  return useQuery<ApiResponse<INotification[]>>(
    queryKeys.notifications.all({ ...params }),
    () => notificationSvc.getAll<INotification>(params),
    options
  )
}

export function useCreateNotification(options: QueryOptions = {}) {
  return useMutation<ApiResponse<INotification>, INotification>(
    (data: INotification) => notificationSvc.create<INotification>(data),
    {
      ...options,
      showLoader: false,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.notifications.root
        })
      }
    }
  )
}

export function useUpdateNotification(options: QueryOptions = {}) {
  return useMutation<ApiResponse<INotification>, { id: string; data: INotification }>(
    ({ id, data }) => notificationSvc.update<INotification>(id, data),
    {
      ...options,
      showLoader: false,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.notifications.root,
          refetchType: 'active'
        })
      }
    }
  )
}

export function useMarkNotificationViewed(options: QueryOptions = {}) {
  return useMutation<ApiResponse<boolean>, string>(
    (data) => notificationSvc.markViewed(data),
    {
      ...options,
      showLoader: false,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.notifications.root,
          refetchType: 'active'
        })
      }
    }
  )
}